import React from "react";
import styled, { keyframes, createGlobalStyle } from "styled-components";
import en from "../language/Eng_Script.json";
import BottomMenu from "./Buttom_menu";

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Noto Sans KR', sans-serif;
    margin: 0;
    padding: 0;
  }
`;

const HEADER_HEIGHT = "80vh";

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
`;

const ScrollDownIndicator = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
  z-index: 100;
  cursor: pointer;

  &::after {
    content: "▼";
    font-size: 24px;
    margin-top: 0;
    animation: ${bounce} 2s infinite;
  }
`;

const PageContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const MainVisualSection = styled.section`
  position: relative;
  width: 100%;
  height: 500px;
  background-image: url(${process.env.PUBLIC_URL + "assets/back_3.jpg"});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  text-align: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const MainContent = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MainTitle = styled.h1`
  font-family: "NotoSansKR";
  font-size: 4em;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    font-size: 2.5em;
  }
`;

const ContentSection = styled.section`
  padding: 80px 60px;
  text-align: center;
  background-color: #ffffff;

  h2 {
    font-size: 2.5em;
    color: #333;
    margin-bottom: 20px;
  }

  p {
    color: #666;
    margin-bottom: 30px;
  }

  @media (max-width: 768px) {
    padding: 60px 30px;
  }
`;

const BoldTitle = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: #333;
  margin-bottom: 15px;
  letter-spacing: 1px;

  @media (max-width: 600px) {
    font-size: 20px;
  }
`;

const StoryTitle = styled.p`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #888;
  margin-bottom: 5px;
`;

const ButtonContainer = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 15px;
    width: 100%;
  }
`;

const BaseButton = styled.a`
  display: inline-block;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;

  @media (max-width: 600px) {
    width: 200px;
    text-align: center;
  }
`;

const OutlineButton = styled(BaseButton)`
  color: #333 !important;
  background-color: transparent;
  border: 2px solid #333;

  &:visited {
    color: #333 !important;
  }

  &:hover {
    color: #ffffff !important;
    background-color: #333;
  }
`;

const Hornsby: React.FC = () => {
  const scrollToContent = () => {
    const contentSection = document.getElementById("ContentSection");
    if (contentSection) {
      window.scrollTo({
        top: contentSection.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <PageContainer>
      <GlobalStyle />
      <MainVisualSection>
        <MainContent>
          <MainTitle>Hornsby</MainTitle>
        </MainContent>
        <ScrollDownIndicator onClick={scrollToContent} />
      </MainVisualSection>

      <ContentSection id="ContentSection">
        <BoldTitle>MENU | RESERVATION</BoldTitle>
        <StoryTitle>{en.menu2.title}</StoryTitle>
        <ButtonContainer>
          <OutlineButton
            href="https://vuzagroup.direct.quickconnect.to/firestone_Hornsby_menu/index.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Hornsby MENU
          </OutlineButton>
          <OutlineButton href="" target="_blank" rel="noopener noreferrer">
            Hornsby RESERVATION (Under preparation)
          </OutlineButton>
          <OutlineButton href="/">HOME</OutlineButton>
        </ButtonContainer>
      </ContentSection>

      <BottomMenu />
    </PageContainer>
  );
};

export default Hornsby;
